/**
 * @module
 *
 * @import {Controller} from "@acng/frontend-stargazer"
 */
import {CLICK, off, on} from '@acng/frontend-bounty/dom/event.js';
import {CONNECT, DESTROY} from '@acng/frontend-stargazer';

/**
 * @implements {Controller}
 */
class ClickController {
  #action;

  /**
   * @param {(this: Element, ev: MouseEvent) => void} action
   */
  constructor(action) {
    this.#action = action;
  }

  /**
   * @param {Element} element
   */
  [CONNECT](element) {
    on(element, CLICK, this.#action);
  }

  /**
   * @param {Element} element
   */
  [DESTROY](element) {
    off(element, CLICK, this.#action);
  }
}

export {ClickController};
